// =============================================================================
// features/sales/campaigns/detail/useDetailTab.ts — Aba ativa refletida na
// querystring (`?tab=<id>`), mesmo padrão de
// wizard/useWizardStepUrl.ts (fora de `files_allowed`, não importado — só o
// mesmo tratamento: reload/link direto sempre volta na mesma aba, DoD do
// slot "5 abas funcionais, com estado na URL").
// =============================================================================

import * as React from 'react';
import { useSearchParams } from 'react-router-dom';

export const DETAIL_TAB_IDS = [
  'visao-geral',
  'carteira',
  'retornos',
  'atividade',
  'configuracao',
] as const;

export type DetailTabId = (typeof DETAIL_TAB_IDS)[number];

export const DETAIL_TAB_LABEL: Record<DetailTabId, string> = {
  'visao-geral': 'Visão geral',
  carteira: 'Carteira',
  retornos: 'Retornos',
  atividade: 'Atividade',
  configuracao: 'Configuração',
};

function isValidTab(raw: string | null): raw is DetailTabId {
  return raw !== null && (DETAIL_TAB_IDS as readonly string[]).includes(raw);
}

export function useDetailTab(): {
  tab: DetailTabId;
  setTab: (next: DetailTabId) => void;
} {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = searchParams.get('tab');
  const tab: DetailTabId = isValidTab(raw) ? raw : 'visao-geral';

  const setTab = React.useCallback(
    (next: DetailTabId) => {
      const params = new URLSearchParams(searchParams);
      params.set('tab', next);
      setSearchParams(params, { replace: true });
    },
    [searchParams, setSearchParams],
  );

  return { tab, setTab };
}
